import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import { yellow } from '@material-ui/core/colors';

interface PACUv2LabelProps {
  label: string;
  variant?: 'default' | 'warning' | 'info' | 'miscellaneous';
}

const PACUv2Label = ({ label, variant }: PACUv2LabelProps) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.label, {
        [classes.labelWarning]: variant === 'warning',
        [classes.labelInfo]: variant === 'info',
        [classes.labelMiscellaneous]: variant === 'miscellaneous',
      })}
    >
      <Typography variant="subtitle2">{label}</Typography>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  label: {
    backgroundColor: theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius,
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.background.default,
  },
  labelWarning: {
    backgroundColor: theme.palette.warning.main,
  },
  labelInfo: {
    backgroundColor: theme.palette.info.main,
  },
  labelMiscellaneous: {
    backgroundColor: yellow[500],
    color: theme.palette.getContrastText(yellow[500]),
  },
}));

export default PACUv2Label;
